import { useEffect, useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(() => setMessage(""), 2600);
    return () => window.clearTimeout(timer);
  }, [message]);

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setMessage("链接已复制，可粘贴到任意平台分享");
    } catch {
      setMessage(`复制失败，可手动复制当前地址栏链接`);
    }
  };

  return (
    <>
      <div className="flex flex-wrap items-center gap-2">
        <button
          onClick={copyLink}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-link text-sm" />
          复制链接
        </button>
        <button
          onClick={() => setMessage("演示分享：可复制链接后前往微博粘贴发布")}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-weibo-line text-sm" />
          分享到微博
        </button>
        <button
          onClick={() => setMessage("演示分享：可复制链接后前往微信发送给好友")}
          className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-2 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-wechat-line text-sm" />
          分享到微信
        </button>
      </div>

      {message ? (
        <div className="fixed bottom-6 left-1/2 z-50 w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 rounded-md border border-background-700 bg-foreground-950 px-4 py-3 text-center text-xs text-background-100 animate-fade-in">
          {message}
          <span className="sr-only">{title}</span>
        </div>
      ) : null}
    </>
  );
}